var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "modal" } }, [
    _c(
      "div",
      {
        staticClass:
          "modal-mask fixed z-50 bg-brand-95 w-full h-full top-0 left-0 flex items-center justify-center flex-col"
      },
      [
        _c(
          "div",
          {
            staticClass:
              "modal-container container px-4 fade-out overflow-y-scroll w-full h-full no-scrollbar"
          },
          [
            _c("div", { staticClass: "modal-header mt-16" }, [
              _c(
                "h2",
                { staticClass: "font-serif font-bold text-white" },
                [
                  _vm._t("header", [_vm._v(" " + _vm._s(_vm.data.title) + " ")])
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "p",
                { staticClass: "font-sans text-white text-2xl md:text-4xl" },
                [_vm._t("header", [_vm._v(_vm._s(_vm.data.type) + " ")])],
                2
              )
            ]),
            _vm._v(" "),
            _vm.data.body
              ? _c("div", {
                  staticClass:
                    "modal-body font-sans text-white overflow-hidden py-8 md:py-16",
                  domProps: { innerHTML: _vm._s(_vm.data.body) }
                })
              : _vm._e()
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "modal-footer py-8 container px-4 flex flex-wrap" },
          [
            _vm._t("footer", [
              _c(
                "a",
                {
                  staticClass: "text-white font-sans w-full",
                  attrs: { href: "mailto:" + _vm.data.email }
                },
                [_vm._v(_vm._s(_vm.data.email))]
              ),
              _vm._v(" "),
              _c(
                "a",
                {
                  staticClass: "text-white font-sans w-full",
                  attrs: { href: "tel:" + _vm.data.phone }
                },
                [_vm._v(_vm._s(_vm.data.phone))]
              )
            ])
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass:
              "absolute right-0 mr-5 mt-2 top-0 font-serif text-white font-bold text-4xl z-50",
            on: {
              click: function($event) {
                return _vm.$emit("close")
              }
            }
          },
          [_vm._v("\n            X\n        ")]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }